import React, { useEffect, useRef, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useSignout } from '../hooks/react-query/useSignIn';

import { Header } from './header/header';
import { useLocation } from 'react-router-dom';
import { MenuBar } from './menuBar/MenuBar';
import usePersonStore from '../store/personStore';
import Loader from '../components/elements/loader';

// let userRole = 'retailUser';

const Layout = () => {
  const navigate = useNavigate();
  const mainRef = useRef(null);

  const { mutate: logout, isLoading: isLogoutLoding } = useSignout();

  const showRetailDashboard = usePersonStore(
    (store) => store.showRetailDashboard
  );

  const location = useLocation();
  const { pathname } = location;

  const [hasOnlyDriversRole, setDriverRole] = useState(false);
  const [impersonateUser, setImpersonateUser] = useState(false);

  const assignedRoles = usePersonStore((store) => store.userRoles);

  useEffect(() => {
    const isPersonate = localStorage.getItem('adminJWT');
    const isGroupPersonate = localStorage.getItem('fleetAdminJWT');
    setImpersonateUser(isPersonate || isGroupPersonate);
  }, [location]);

  useEffect(() => {
    if (assignedRoles && assignedRoles.length) {
      const hasDriversRole =
        assignedRoles.length === 1 && assignedRoles.includes('driver');
      setDriverRole(hasDriversRole);
    }
  }, [assignedRoles]);

  const handleLogout = () => {
    logout({
      onSuccess: () => {
        navigate('/');
      },
    });
  };

  const navigateToDashboard = () => {
    if(assignedRoles.length > 0 && !pathname.includes('/dashboard'))
     navigate('/dashboard');
  };

  
  useEffect(() => {
    // scroll the <main> container (not window!)
    if (mainRef.current) {
      mainRef.current.scrollTo({ top: 0, left: 0, behavior: "auto" });
      // or: mainRef.current.scrollTop = 0;
    }
  }, [pathname]);


  return (
    <div className="flex flex-col h-screen relative">
      {isLogoutLoding && <Loader className="fill-primary" />}
      <Header
        impersonateUser={impersonateUser}
        handleLogout={handleLogout}
        handleDasboardClick={navigateToDashboard}
      />

      <div className="flex flex-col max-lg:flex-col-reverse h-full">
        <main
          ref={mainRef}
          className="w-full h-full overflow-auto scrollbar"
          style={
            (pathname.includes("/service-booking") || pathname.includes("/service/notifications_guide"))
              ? { backgroundColor: "#F5F5F7", backgroundImage: "none" }
              : pathname.includes("/loyalty/register")
                ? { background: "url('/avis/images/loyalty-register-background.png') center/cover no-repeat" }
                : { background: "url('/bg-dashboard.svg') center/cover no-repeat" }
          }
        >
          <Outlet />
        </main>

        {showRetailDashboard && 
        !pathname.includes('track-your-car') && 
        !pathname.includes('/service-booking') && 
        !pathname.includes('/vehicledelivery') && 
        !pathname.includes('/portal/loyalty/profile') && 
        (
          <MenuBar hasOnlyDriversRole={hasOnlyDriversRole} />
        )}
      </div>
    </div>
  );
};

export default Layout;
